import { TreatmentAnalysis } from '../translations-types';

const translations: TreatmentAnalysis = {
  title: 'Treatment analysis',
  description:
    "Analyse a customer's treatments over a period and generate an overview of which type of annual plan the customer followed this year.",
  selectCustomer: 'Customer',
  customerPlaceholder: 'Choose a customer',
  period: 'Period',
  generate: 'Generate analysis',
  generating: 'Analysing…',
  resultTitle: 'Analysis',
  empty: 'Choose a customer and a period, then generate the analysis.',
  analyse: 'Analyse',
  confirmTitle: 'Start analysis',
  confirmContent: 'customer(s) will be analysed (1 credit per customer). Continue?',
  analyseDone: 'Analysis completed',
  failuresTitle: 'Failed for these customers',
  lastAnalysis: 'Last analysis',
  noAnalysis: 'No analysis yet',
  historyButton: 'Treatments & services',
  kindAppointment: 'Appointment',
  kindService: 'Service',
  colDate: 'Date',
  colType: 'Type',
  colTreatment: 'Treatment',
  colEmployee: 'Employee',
  historyEmpty: 'No appointments or services in this period',
};

export default translations;
